import { AccommodationArrangedStatusEnum, AccommodationTypeStatusEnum } from 'types';
import { IAccommodationStatus } from '../../../../../types';

interface IAccommodationStatusColorProps {
  accommodationStatus: IAccommodationStatus;
}

interface IAccommodationStatusDescriptionProps {
  accommodationStatus: IAccommodationStatus;
}

export const AccommodationStatusDescription = ({ accommodationStatus }: IAccommodationStatusDescriptionProps) => {
  const accommodationArrangedStatus = accommodationStatus.arrangedStatus || AccommodationArrangedStatusEnum.NONE;
  const accommodationTypeStatus = accommodationStatus.typeStatus || AccommodationTypeStatusEnum.NONE;

  const youToldText = 'You have told us your status is';
  const pleaseUpdateText = ' Please update this when your status changes.';

  if (
    accommodationArrangedStatus === AccommodationArrangedStatusEnum.NONE ||
    accommodationTypeStatus === AccommodationTypeStatusEnum.NONE
  ) {
    return 'You have not set an accommodation status.';
  }
  const isArranged = accommodationArrangedStatus === AccommodationArrangedStatusEnum.ARRANGED;

  const arrangedText = isArranged ? 'arranged' : 'not arranged';
  const consideringText =
    !isArranged && accommodationTypeStatus !== AccommodationTypeStatusEnum.I_DONT_KNOW ? 'considering ' : '';

  let accommodationStatusText = '';

  switch (accommodationTypeStatus) {
    case AccommodationTypeStatusEnum.UNIVERSITY_ACCOMMODATION:
      accommodationStatusText = `University accommodation`;
      break;

    case AccommodationTypeStatusEnum.PRIVATE_STUDENT_ACCOMMODATION:
      accommodationStatusText = `private student accommodation`;
      break;

    case AccommodationTypeStatusEnum.PRIVATE_RENTAL:
      accommodationStatusText = `private rental`;
      break;

    case AccommodationTypeStatusEnum.STAYING_WITH_FAMILY:
      accommodationStatusText = `staying with family`;
      break;

    case AccommodationTypeStatusEnum.HOMESTAY:
      accommodationStatusText = `homestay`;
      break;

    case AccommodationTypeStatusEnum.OTHER:
      accommodationStatusText = `other`;
      break;

    case AccommodationTypeStatusEnum.I_DONT_KNOW:
      accommodationStatusText = `unsure`;
      break;

    default: {
      accommodationStatusText = accommodationTypeStatus;
      break;
    }
  }

  return (
    <>
      {youToldText} <b>{`${arrangedText} - ${consideringText}${accommodationStatusText}`}</b>.
      {!isArranged ? pleaseUpdateText : null}
    </>
  );
};

export const statusColorScheme = ({ accommodationStatus }: IAccommodationStatusColorProps) => {
  const accommodationArrangedStatus = accommodationStatus.arrangedStatus || AccommodationArrangedStatusEnum.NONE;

  switch (accommodationArrangedStatus) {
    case AccommodationArrangedStatusEnum.NOT_ARRANGED:
      return 'orange';

    case AccommodationArrangedStatusEnum.ARRANGED:
      return 'green';

    default:
      return 'orange';
  }
};
